import React from 'react';
import { Text } from '@adobe/react-spectrum';
import styles from './SectionLabel.module.scss';

interface SectionLabelProps {
  label: string;
}

export function SectionLabel({ label }: SectionLabelProps) {
  return <Text UNSAFE_className={styles.sectionLabel}>{label}:</Text>;
}
